import { SyncEntity } from "../../../../../../src/entity/Sync";
import GoogleCalendarLogo from "../components/google_calendar_logo";

export function GoogleCalendarTag(props: { sync: SyncEntity }) {
	return (
		<span
			className="tag tag-dark-gray min-w-0 max-w-full gap-2 sm:max-w-[45%]"
			title={`GCal - ${props.sync.gcal_name}`}
		>
			<GoogleCalendarLogo isDim />
			<span className="has-text-weight-bold min-w-0 truncate">
				{props.sync.gcal_name}
			</span>
		</span>
	);
}
